// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"b8b23ebb","186":"04a22602","225":"25c6d537","315":"55cc9c74","344":"f1dd9b57","372":"9c99c8a1","496":"9e9ddb11","738":"38dc0aa7","841":"6acf07a2","856":"e91b8e18"}[chunkId] + ".chunk.js";
};